import React from "react";
import { Box, Typography } from "@mui/material";
import { SelectedGame } from "../../types/game";

interface PickerHeaderProps {
  pickedCount: number;
  totalGames: number;
  lockCount: number;
  maxLocks: number;
  showLocks: boolean;
  showGameOfTheWeek: boolean;
  gameOfTheWeek: number | undefined;
  games: SelectedGame[];
  isMobile: boolean;
}

export const PickerHeader: React.FC<PickerHeaderProps> = ({
  pickedCount,
  totalGames,
  lockCount,
  maxLocks,
  showLocks,
  showGameOfTheWeek,
  gameOfTheWeek,
  games,
  isMobile,
}) => {
  const getGameOfTheWeekInfo = () => {
    if (!gameOfTheWeek) return null;
    const game = games.find((g) => g.game.id === gameOfTheWeek);
    if (!game) return null;
    return {
      homeTeam: game.homeTeam.abbreviation,
      awayTeam: game.awayTeam.abbreviation,
    };
  };

  const gotwInfo = getGameOfTheWeekInfo();

  if (isMobile) {
    return (
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <Typography variant="body2" fontWeight={800}>
          {pickedCount}/{totalGames} picked
        </Typography>
        {showLocks && (
          <Typography variant="body2" color="text.secondary">
            {lockCount}/{maxLocks} locks
          </Typography>
        )}
        {showGameOfTheWeek && gotwInfo && (
          <Typography variant="body2" fontWeight={700} color="warning.dark">
            GOTW: {gotwInfo.homeTeam} vs {gotwInfo.awayTeam}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
      <Typography variant="body2" fontWeight={800}>
        {pickedCount} of {totalGames} picks
      </Typography>
      {showLocks && (
        <Typography variant="body2" color="text.secondary">
          {lockCount} of {maxLocks} locks
        </Typography>
      )}
      {showGameOfTheWeek && gotwInfo && (
        <Typography variant="body2" color="warning.dark" fontWeight={700}>
          GOTW: {gotwInfo.homeTeam} vs {gotwInfo.awayTeam}
        </Typography>
      )}
    </Box>
  );
};
